export default class extends HTMLElement {
  connectedCallback () {
    this.button = this.querySelector('[data-show-all]')
    this.hiddenItems = this.querySelectorAll('[data-more-item]')

    this.button?.addEventListener('click', () => this.expand())
  }

  expand () {
    this.hiddenItems.forEach((item) => item.classList.remove('hidden'))
    this.button?.classList.add('hidden')
  }
}
